import React from "react";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";
import LightHeader from "./LightHeader.js";
import LightSistemas from "./LightSistemas.js";
import LightConheca from "./LightConheca.js";
import LightTitulo from "./LightTitulo.js";
import LightBeneficios from "./LightBeneficios.js";
import LightRecursos from "./LightRecursos.js";

function Light() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="main">
          <LightHeader />
          <LightTitulo />
          <LightBeneficios />
          <LightRecursos />
          <LightConheca />
          <LightSistemas />
        </div>
        <Footer />

      </div>
      <img
          alt="wpp-fab"
          onClick={() => window.open("https://wa.me/554530569085")}
          className="wpp-fab"
          src={require("assets/img/wpp.png")}
      ></img>
    </>
  );
}

export default Light;
